export type { PageProps } from "./Page"
export type { PageHeaderProps } from "./PageHeader"
export type { PageContentProps } from "./PageContent"
export type { PageSidebarProps } from "./PageSidebar"
export type { PageWrapperProps } from "./PageWrapper"

import Page from "./Page"
import PageHeader from "./PageHeader"
import PageHeaderActions from "./PageHeaderActions"
import PageTitle from "./PageTitle"
import PageSidebar from "./PageSidebar"
import PageContent from "./PageContent"
import PageWrapper from "./PageWrapper"

export default Object.assign(Page, {
  Header: Object.assign(PageHeader, {
    Actions: PageHeaderActions,
  }),
  Title: PageTitle,
  Sidebar: PageSidebar,
  Content: PageContent,
  Wrapper: PageWrapper,
})
